module.exports = __webpack_public_path__ + "img/carrot.d3836db1.svg";